export default "__VITE_ASSET__CIFpLKbc__"